import React from 'react';

const UserDashboardPage = () => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('auth_user'));
  } catch (e) {}

  return (
    <>
      <style>{`
        .user-dashboard-wrapper {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .user-welcome-card {
          background: linear-gradient(135deg, #1e3a8a, #3b82f6);
          border-radius: 16px;
          padding: 32px;
          color: white;
          box-shadow: 0 10px 30px rgba(37, 99, 235, 0.15);
          position: relative;
          overflow: hidden;
        }

        .user-welcome-bg-shape {
          position: absolute;
          width: 200px;
          height: 200px;
          background: radial-gradient(circle, rgba(255,255,255,0.15), transparent 70%);
          border-radius: 50%;
          top: -50px;
          right: -20px;
        }

        .user-welcome-bg-shape-2 {
          position: absolute;
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, rgba(255,255,255,0.08), transparent 70%);
          border-radius: 50%;
          bottom: -150px;
          left: 10%;
        }

        .user-welcome-content {
          position: relative;
          z-index: 1;
        }

        .user-welcome-title {
          font-size: 28px;
          font-weight: 800;
          margin: 0 0 8px;
          letter-spacing: -0.5px;
        }

        .user-welcome-desc {
          font-size: 15px;
          color: rgba(255,255,255,0.85);
          margin: 0 0 24px;
          max-width: 500px;
          line-height: 1.6;
        }

        .user-welcome-actions {
          display: flex;
          gap: 12px;
        }

        .user-btn-primary {
          background: white;
          color: #1e3a8a;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .user-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.15);
        }

        .user-stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 20px;
        }

        .user-stat-card {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .user-stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.03);
          border-color: #cbd5e1;
        }

        .user-stat-icon {
          width: 52px;
          height: 52px;
          border-radius: 12px;
          background: #eff6ff;
          color: #3b82f6;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          flex-shrink: 0;
        }

        .user-stat-info {
          display: flex;
          flex-direction: column;
        }

        .user-stat-label {
          font-size: 13px;
          color: #64748b;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
        }

        .user-stat-value {
          font-size: 26px;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }
      `}</style>

      <div className="user-dashboard-wrapper">
        <div className="user-welcome-card">
          <div className="user-welcome-bg-shape"></div>
          <div className="user-welcome-bg-shape-2"></div>
          <div className="user-welcome-content">
            <h1 className="user-welcome-title">Welcome back, {user?.name || 'User'}!</h1>
            <p className="user-welcome-desc">
              Your client portal is ready. You can start filing new tax returns, upload necessary documents, or check the status of your existing filings right here.
            </p>
            <div className="user-welcome-actions">
              <button className="user-btn-primary">
                <i className="fa-solid fa-plus"></i>
                Start New Filing
              </button>
            </div>
          </div>
        </div>

        <div className="user-stats-grid">
          <div className="user-stat-card">
            <div className="user-stat-icon" style={{ background: '#eff6ff', color: '#3b82f6' }}>
              <i className="fa-solid fa-file-invoice"></i>
            </div>
            <div className="user-stat-info">
              <span className="user-stat-label">Active Filings</span>
              <span className="user-stat-value">0</span>
            </div>
          </div>
          <div className="user-stat-card">
            <div className="user-stat-icon" style={{ background: '#ecfdf5', color: '#10b981' }}>
              <i className="fa-solid fa-circle-check"></i>
            </div>
            <div className="user-stat-info">
              <span className="user-stat-label">Completed</span>
              <span className="user-stat-value">0</span>
            </div>
          </div>
          <div className="user-stat-card">
            <div className="user-stat-icon" style={{ background: '#fef3c7', color: '#f59e0b' }}>
              <i className="fa-solid fa-clock-rotate-left"></i>
            </div>
            <div className="user-stat-info">
              <span className="user-stat-label">Pending Action</span>
              <span className="user-stat-value">0</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDashboardPage;
